import { render, staticRenderFns } from "./MortgagesManager.vue?vue&type=template&id=dd32f376"
import script from "./MortgagesManager.vue?vue&type=script&lang=ts"
export * from "./MortgagesManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports